// extracted by mini-css-extract-plugin
export default {"steps":"StepsConfig_steps__eLmOa"};